module.exports = __webpack_public_path__ + "static/media/arrow-right.d200fe9a.png";